import { setUser as setSentryUser } from "@sentry/react"
import trackEvent from "./trackEvent"

// TODO: Switch to umami.identify when session is not broken by it
// https://github.com/umami-software/umami/issues/3820
export default async (id: string) => {
  setSentryUser({ id })
  await trackEvent("auth", { id })
}
